import React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var PrySVG = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#0038A8",
  d: "M0 27a4 4 0 004 4h28a4 4 0 004-4v-4H0v4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M0 13h36v10H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D52B1E",
  d: "M32 5H4a4 4 0 00-4 4v4h36V9a4 4 0 00-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 18a4 4 0 11-8 0 4 4 0 018 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M21.75 18a3.75 3.75 0 11-7.501-.001A3.75 3.75 0 0121.75 18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 18a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M21.126 18a3.125 3.125 0 11-6.25.002 3.125 3.125 0 016.25-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#99AAB5",
  d: "M21.132 17.98a3.132 3.132 0 10-5.841 1.573l2.712-1.491 2.707 1.491c.268-.463.422-1 .422-1.573z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5 18a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EEE",
  cx: "18",
  cy: "18",
  r: "2.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAC33",
  d: "M18 17.182l.184.565h.594l-.481.35.183.565-.48-.349-.48.349.183-.565-.481-.35h.594z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007127",
  d: "M18.497 16.517s.3-.07.476-.088c.176-.018.334.388.545.458.214.072.212.282.3.529.088.247.035.299.035.581s.158.423.123.634c-.035.211-.211.264-.316.405-.105.142-.018.317-.124.423-.105.105-.458.088-.581.194-.123.105-.352.264-.511.176-.158-.088-.493-.123-.493-.123s.088-.317.335-.423c.247-.105.352-.088.581-.158.229-.071.211-.177.37-.317.158-.141.176-.335.264-.476.089-.141.106-.247.071-.441a3.298 3.298 0 00-.177-.582c-.07-.176-.229-.387-.335-.511-.105-.123-.563-.281-.563-.281z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007127",
  d: "M17.405 16.622s.175-.383 0-.405c-.705-.088-.846.546-1.057.616-.213.072-.247.423-.334.669-.088.247-.053.299-.053.582 0 .282.005.334.041.546.035.211.083.37.188.511.106.141.146.211.252.316.105.105.312.212.435.317.123.105.498.141.657.053.158-.088.435-.123.435-.123s-.118-.212-.364-.317c-.247-.105-.264-.193-.493-.264-.229-.071-.211-.177-.37-.317-.158-.141-.176-.335-.264-.476-.088-.141-.041-.176-.005-.37.035-.194.105-.352.176-.528.07-.176.247-.405.352-.528.105-.123.404-.282.404-.282z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#007127",
  d: "M17.423 19.863l.229.158.299-.211.282.194.37-.141-.37.265-.264-.212-.282.194-.282-.159z"
})));

export { PrySVG as default };
//# sourceMappingURL=bundle.esm6.js.map
